module.exports = __webpack_public_path__ + "static/img/6h.f1a7ca9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/6h.svg
// module id = 4047
// module chunks = 1